export default {
    common:{
        english: 'English',
        india: 'India',
        unit: 'INR',
        nodata: 'No data available',
        save: "save",
        all: 'All',
        repulling:"Quickly copy the dropdown process",
        reloosing:"Release process prompt copy",
        reloading:"Loading prompt copy",
        resuccess:"Refresh prompt copy successfully",
    },
    footer:{
        home:'Home',
        gallery: 'Image Gallery',
        match: 'Match',
        verification:'Verification',
        mine: 'Mine'
    },
    match:{
        title: 'The Best Night'
    },
    login:{
        register:'Register',
        nameple: 'Please enter your username',
        pwdple: 'Please enter password',
        agepwdple: 'Re-enter password',
        codeple: 'Please enter the invitation code',
        agree: 'Agree to the Terms of Use',
        tips: 'Do you have an account? Register as a member now.',
        login: 'Login'
    },
    mine:{
        creditscore:'Credit score',
        points: 'Accumulated points',
        recharge: 'Recharge',
        withdraw: 'Withdraw',
        available: 'Available Balance',
        frozen: 'Frozen Balance',
        information:'Essential Information',
        pointshistory: 'Points History',
        withdrawdetails: 'Withdraw Details',
        giftrecord: 'Gift Record',
        matters: 'Announcement Matters',
        watch: 'Watch History',
        loginpwd: 'Login Password',
        usrpwd: 'Use Password',
        mybank: 'My Bank',
        cancellation: 'Cancellation'
    },
    recharge:{
        point: 'Having a point',
        remark: 'If you want offline charging, please consult customer service. The recharge amount of some settlement channels will be randomly recharged to one decimal place. Please be sure to confirm during settlement',
        toserve: 'Please contact customer service'
    },
    service:{
        title: 'Online Service',
        name: 'Dream Kingdom Club',
        link: 'Contact',
        tip: 'We are dedicated to serving you 24/7',
    },
    infomation:{
        memberid: 'Member ID',
        fullname: 'Full Name',
        bank: 'Bank Account Details',
        phone: 'Phone Number',
        newphone: 'New Phone Number',
        phone_place: 'Please enter new phone number',
        setname: 'Change Real Name',
        name: 'Name',
        name_place: "please enter your real name",
        name_tip: "For the security of your account, the real name needs to be the same as the name of the bound bank card",
        
    },
    bank:{
        title: 'Bank Account Details',
        pushbtn: 'Add Your Bank Account Details',
        bankname: 'Bank Name',
        banknameple: 'Please enter bank name',
        pername: "Recipient's Name",
        pernameple: 'Please enter full name',
        accountNo: 'Account Number',
        accountNople: 'Please enter account number',
        ifsc: 'IFSC',
        ifscple: 'Please enter IFSC code',
        pwd: 'Withdrawal Password',
        pwdple: 'Please enter withdrawal password',
        btn: 'Bank Account Details'
    },
    index: {
        girl: 'Popularity Recommendation List',
        advanced:'Advanced',
        certification: 'On site certification',
        authentication: 'My own video authentication',
        rating: 'Rating',
        apply: 'Apply for a date',
        accounttitle: 'Real time status',
        accountmsg: '{name} Joined as a member'
    },
    verification:{
        title:'Verification',
        benefit:'VIP Benefit'
    },
    profile:{
        profile:'Girls profile',
        click: 'Click on authentication'
    },
    reservation: {
        bearer:'standdard-bearer',
        data:'data',
        time: 'Remaining time',
        round: 'Round',
        quantity: 'Quantity',
        poinnts: 'Available Points',
        morepro: 'More Products',
        itemerror: 'You can only select up to 2 items',

        "hall": "Reservation hall",
        "refresh": "Refresh successfully",
        "money_err": "wrong amount",
        "choose_num": "Please choose a item!",
        "balance_enough": "Insufficient balance, please contact customer service to recharge!",
        "contact_admin": "Please contact the administrator for this task!",
        "prize_succ": "The lottery draw is successful, the issue number:",
        "task_list": "mission list",
        "available_balance": "Available Balance",
        "counselor": "Please contact an advisor or receptionist",
        "clear_order": "Clear order",
        "submit": "Confirm",
        "num": "Issue",
        "win_num": "Winning numbers",
        "curr_choose": "Current Selection",
        "per_price": "Amount per bet",
        "price_place": "Please enter the amount",
        "unit": "Ticket",
        "total": "Total",
        "note": "Note",
        "money": "bet amount",
        "order_time": "order time",
        "settle_time": "settlement time",
        "no_choose": "Unselected",
        "big": "A",
        "small": "B",
        "double": "D",
        "single": "C",
        "win_formula": "Profit Calculation Formula: Winning Amount - Task Amount"
    },
    "video": {
        "video": "video theater",
        "play": "play",
        "no_more": "no more",
        "num_play": "plays",
        "account_out": "Account offline",
        "buy": "Please recharge and watch the video",
        "recmonmand": "Popular recommendation",
        welcome: 'Hi,{name}',
        tickets: 'Complete tasks to get more movie tickets',
        num:'Movie Reel',
        title:'Watch List'
    },
    "withdraw": {
        "with_center": "Withdrawal",
        "with_record": "Detail",
        "with_money": "Withdrawal Amount",
        "recharge_money": "Recharge amount",
        "task_money": "task amount",
        "win_money": "winning amount",
        "single_limit": "single limit",
        "low": "lowest",
        "heigh": "Highest",
        "with_num": "Number of withdrawals: maximum withdrawal in one day",
        "number": "Second-rate",
        "with_tip": "Arrival time: Generally, the arrival time is about 5 minutes, and the fastest arrival time is 2 minutes.",
        "limit_desc": "Limit description",
        "immediately_withdraw": "Withdraw immediately",
        "empty_data": "data is empty",
        "money": "Amount",
        "desc": "illustrate",
        "submit_time": "submission time",
        "check_time": "Review time",
        "with_service": "The withdrawal password has been set. If you need to modify it, please contact customer service."
    },
    "setting": {
        "setting": "set up",
        "base_setting": "Basic Information",
        "login_pwd": "Login Password",
        "finance_pwd": "Fund password",
        "language": "language selection",
        "logout": "sign out",
        "avatar": "avatar",
        "choose_avatar": "Choose Avatar",
        "ok": "Sure",
        "cancel": "Cancel",
        "real_name": "actual name",
        "modify_real_name": "Edit real name",
        "name_place": "please enter your real name",
        "save": "save",
        "name": "name",
        "name_tip": "For the security of your account, the real name needs to be the same as the name of the bound bank card",
        "repect": "Do not repeat the settings!",
        "sex": "gender",
        "sex_place": "gender modification",
        "man": "male",
        "female": "Female",
        "unkown": "Unknown",
        "no_setting": "not set",
        "y_setting": "Has been set",
        "bindinged": "bound",
        "no": "none",
        "login_pwd_tip": "Modify login password",
        "old_pwd": "Old Password",
        "new_pwd": "new password",
        "old_pwd_tip": "Please enter your old password",
        "new_pwd_tip": "Please enter your new password",
        "new_again_tip": "Please enter your new password again",
        "prefect": "Please fill in completely!",
        "pwd_error": "Inconsistent password entered twice",
        "set_money_pwd": "Set up a fund password",
        "money_place": "Please enter the fund password",
        "money_again_place": "Please enter the fund password again",
        "correct_money": "Please fill in the correct amount",
        "contact_recharge": "Please contact customer service to recharge",
        "set_bank": "Please set up a payment card",
        "forbid": "feature disabled",
        "log_reg": "log in Register",
        "more_service": "Sign in to enjoy more services!",
        "bind_bank_info": "Bind bank card information",
        "bank_info": "bank card information",
        "add_bank": "Add a bank card",
        "bind_bank_tip": "Tip: Please bind a large commercial bank, if you need to modify, please contact online customer service",
        "fill_bank": "Fill in the payment card",
        "fill_bank_tip": "Please enter your payment card information",
        "band_account": "Bank card number",
        "set_name_bank": "Please set your name before binding your bank card!",
        "set_pwd_bank": "Please set the withdrawal password before binding the bank card!",
        "band_name": "Bank name",
        "band_account_tip": "Please enter real bank card number",
        "band_name_tip": "Please select a bank",
        "bank_warn": "Dear users, in order to ensure the safety of your funds, please bind your real name and set a withdrawal password. If the name is inconsistent with the account name, you will not be able to withdraw money",
        "bank_ok": "Make sure to bind the card",
        "username":"Name",
        "username_place":"please enter your real name",
        "mobile":"Phone number",
        "mobile_place":"Please type your phone number"
    }
}